<template>
    <div class="about">
        <h1>关于我们</h1>
        <router-link to="/other">About111</router-link>
        <br />
        <br />
        <br />
        <br />
        <a href="/other"></a>
        <el-button @click="aaaaaaaaaaaaaaa" type="primary">主要按钮</el-button>
        <el-button @click="loadingaaaaa" type="primary">loading</el-button>
        <h1>This is an about page</h1>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "about",
    // metaInfo: {
    //   title: '测试标题', // set a title
    //   meta: [{                 // set meta
    //     name: 'keyWords',
    //     content: '关键字内容'
    //   }],
    //   link: [{                 // set link
    //     rel: 'asstes',
    //     href: 'https://aaaaaaaaaaa/'
    //   }]
    // },
    metaInfo() {
        return {
            title: this.pageName,
            meta: [
                {
                    name: "keyWords",
                    content: this.content
                },                
                {
                    name: "description",
                    content: this.description
                }
            ],
            link: [
                {
                    rel: "asstes",
                    href: this.ahref
                }
            ]
        };
    },
    data() {
        return {
            pageName: "loading",
            content: "关键字内容",
            ahref: "https://aaaaaaaaaaa/",
            description:'这里是描述内容SEO'
        };
    },
    mounted() {
        setTimeout(() => {
            this.pageName = "asyncaaaaaaaaaaaaaaaaaaaaaa";
        }, 2000);
    },
    methods: {
        loadingaaaaa() {
            this.setLoading(true);
            setTimeout(() => {
                this.setLoading(false);
            }, 3000);
        },
        aaaaaaaaaaaaaaa() {
            this.$message.error("啊啊啊啊啊啊啊啊啊啊啊啊");
            // this.$router.push({ name: "Other" });
        },
        ...mapActions(["setLoading"])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(["loading"])
    },
    components: {}
};
</script>

<style lang="scss" type="text/scss">
.about {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background-color: pink;
    
    
    h1 {
        color: red;
    }
        
}
</style>